export default "__VITE_ASSET__BtVUkTyT__"